<template>
<div class="index">
    <div class="overlay-menu">
        <div id="projets" class="tablecon">
            <div class="row th list">
                <div class="col-12 ta titlecont">Table of Contents</div>
            </div>
            <div id="table_content">
                <a @click="turnPage(10)" class="row list">
                    <div class="col-12 col-sm-9">#HumanIssue - Alex Honnold</div>
                    <div class="hidden-xs col-sm-3"><span>8</span></div>
                </a>
                <a @click="turnPage(21)" class="row list">
                    <div class="col-xs-12 col-sm-9">Editor's Letter</div>
                    <div class="hidden-xs col-sm-3">19</div>
                </a>
                <a @click="turnPage(24)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Bryan Stevenson</div>
                    <div class="hidden-xs col-sm-3">22</div>
                </a>
                <a @click="turnPage(26)" class="row list">
                    <div class="col-xs-12 col-sm-9">Masthead</div>
                    <div class="hidden-xs col-sm-3">24</div>
                </a>
                <a @click="turnPage(28)" class="row list">
                    <div class="col-xs-12 col-sm-9">Contributors</div>
                    <div class="hidden-xs col-sm-3">26</div>
                </a>
                <a @click="turnPage(32)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Constance Wu</div>
                    <div class="hidden-xs col-sm-3">30</div>
                </a>
                <a @click="turnPage(34)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Adom Appiah</div>
                    <div class="hidden-xs col-sm-3">32</div>
                </a>
                <a @click="turnPage(36)" class="row list">
                    <div class="col-xs-12 col-sm-9">Eco Edits</div>
                    <div class="hidden-xs col-sm-3">34</div>
                </a>
                <a @click="turnPage(40)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Anna Du</div>
                    <div class="hidden-xs col-sm-3">38</div>
                </a>
                <a @click="turnPage(44)" class="row list">
                    <div class="col-xs-12 col-sm-9">The Journey Home</div>
                    <div class="hidden-xs col-sm-3">42</div>
                </a>
                <a @click="turnPage(50)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Ewan McGregor</div>
                    <div class="hidden-xs col-sm-3">48</div>
                </a>
                <a @click="turnPage(52)" class="row list">
                    <div class="col-xs-12 col-sm-9">An Education</div>
                    <div class="hidden-xs col-sm-3">50</div>
                </a>
                <a @click="turnPage(58)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Aryaman Khandelwal</div>
                    <div class="hidden-xs col-sm-3">56</div>
                </a>
                <a @click="turnPage(60)" class="row list">
                    <div class="col-xs-12 col-sm-9">Sister Act</div>
                    <div class="hidden-xs col-sm-3">58</div>
                </a>
                <a @click="turnPage(66)" class="row list">
                    <div class="col-xs-12 col-sm-9">Keeping the Collective</div>
                    <div class="hidden-xs col-sm-3">64</div>
                </a>
                <a @click="turnPage(74)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - FKA twigs </div>
                    <div class="hidden-xs col-sm-3">72</div>
                </a>
                <a @click="turnPage(76)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Bana Alabed </div>
                    <div class="hidden-xs col-sm-3">74</div>
                </a>
                <a @click="turnPage(78)" class="row list">
                    <div class="col-xs-12 col-sm-9">For Art Itself </div>
                    <div class="hidden-xs col-sm-3">76</div>
                </a>
                <a @click="turnPage(86)" class="row list">
                    <div class="col-xs-12 col-sm-9">Mind Over Matter </div>
                    <div class="hidden-xs col-sm-3">84</div>
                </a>
                <a @click="turnPage(92)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - George Clooney</div>
                    <div class="hidden-xs col-sm-3">90</div>
                </a>
                <a @click="turnPage(94)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Camryn Garrett</div>
                    <div class="hidden-xs col-sm-3">92</div>
                </a>
                <a @click="turnPage(96)" class="row list">
                    <div class="col-xs-12 col-sm-9">ROCK STAR</div>
                    <div class="hidden-xs col-sm-3">94</div>
                </a>
                <a @click="turnPage(104)" class="row list">
                    <div class="col-xs-12 col-sm-9">I AM IRONMAN</div>
                    <div class="hidden-xs col-sm-3">102</div>
                </a>
                <a @click="turnPage(110)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Helena Bonham Carter</div>
                    <div class="hidden-xs col-sm-3">108</div>
                </a>
                <a @click="turnPage(112)" class="row list">
                    <div class="col-xs-12 col-sm-9">The Rise of the Conscious Male</div>
                    <div class="hidden-xs col-sm-3">110</div>
                </a>
                <a @click="turnPage(118)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Caroline Dubois</div>
                    <div class="hidden-xs col-sm-3">116</div>
                </a>
                <a @click="turnPage(120)" class="row list">
                    <div class="col-xs-12 col-sm-9">On a Trip</div>
                    <div class="hidden-xs col-sm-3">118</div>
                </a>
                <a @click="turnPage(128)" class="row list">
                    <div class="col-xs-12 col-sm-9">Talking to Coco</div>
                    <div class="hidden-xs col-sm-3">126</div>
                </a>
                <a @click="turnPage(134)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Grace Callwood</div>
                    <div class="hidden-xs col-sm-3">132</div>
                </a>
                <a @click="turnPage(138)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Idris Elba</div>
                    <div class="hidden-xs col-sm-3">136</div>
                </a>
                <a @click="turnPage(140)" class="row list">
                    <div class="col-xs-12 col-sm-9">The Miracle of ALOK</div>
                    <div class="hidden-xs col-sm-3">138</div>
                </a>
                <a @click="turnPage(148)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Dr. Jane Goodall</div>
                    <div class="hidden-xs col-sm-3">146</div>
                </a>
                <a @click="turnPage(150)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Hannah Lucas</div>
                    <div class="hidden-xs col-sm-3">148</div>
                </a>
                <a @click="turnPage(152)" class="row list">
                    <div class="col-xs-12 col-sm-9">Arrested Development</div>
                    <div class="hidden-xs col-sm-3">150</div>
                </a>
                <a @click="turnPage(164)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Kerby Jean-Raymond</div>
                    <div class="hidden-xs col-sm-3">162</div>
                </a>
                <a @click="turnPage(166)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Jahkil Jackson</div>
                    <div class="hidden-xs col-sm-3">164</div>
                </a>
                <a @click="turnPage(168)" class="row list">
                    <div class="col-xs-12 col-sm-9">Fashion-As You Are, As You Were, As You Want To Be</div>
                    <div class="hidden-xs col-sm-3">166</div>
                </a>
                <a @click="turnPage(182)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Kevin J. Patel</div>
                    <div class="hidden-xs col-sm-3">180</div>
                </a>
                <a @click="turnPage(184)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - LeBron James</div>
                    <div class="hidden-xs col-sm-3">182</div>
                </a>
                <a @click="turnPage(186)" class="row list">
                    <div class="col-xs-12 col-sm-9">Jeremy O. Harris  </div>
                    <div class="hidden-xs col-sm-3">184</div>
                </a>
                <a @click="turnPage(192)" class="row list">
                    <div class="col-xs-12 col-sm-9">The Many Faces of Lyle XOX</div>
                    <div class="hidden-xs col-sm-3">190</div>
                </a>
                <a @click="turnPage(200)" class="row list">
                    <div class="col-xs-12 col-sm-9">In Excess</div>
                    <div class="hidden-xs col-sm-3">198</div>
                </a>
                <a @click="turnPage(206)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Licypriya Kangujam</div>
                    <div class="hidden-xs col-sm-3">204</div>
                </a>
                <a @click="turnPage(210)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Lena Waithe</div>
                    <div class="hidden-xs col-sm-3">208</div>
                </a>
                <a @click="turnPage(212)" class="row list">
                    <div class="col-xs-12 col-sm-9">One for All</div>
                    <div class="hidden-xs col-sm-3">210</div>
                </a>
                <a @click="turnPage(218)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Malala Yousafzai</div>
                    <div class="hidden-xs col-sm-3">216</div>
                </a>
                <a @click="turnPage(220)" class="row list">
                    <div class="col-xs-12 col-sm-9">The Only Girl in the World</div>
                    <div class="hidden-xs col-sm-3">218</div>
                </a>
                <a @click="turnPage(230)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Megan Rapinoe</div>
                    <div class="hidden-xs col-sm-3">228</div>
                </a>
                <a @click="turnPage(232)" class="row list">
                    <div class="col-xs-12 col-sm-9">Care More About Making the Art Than the Art Itself</div>
                    <div class="hidden-xs col-sm-3">230</div>
                </a>
                <a @click="turnPage(244)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue – Noname</div>
                    <div class="hidden-xs col-sm-3">242</div>
                </a>
                <a @click="turnPage(246)" class="row list">
                    <div class="col-xs-12 col-sm-9">Refugees Are Human</div>
                    <div class="hidden-xs col-sm-3">244</div>
                </a>
                <a @click="turnPage(248)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Malavika Kannan </div>
                    <div class="hidden-xs col-sm-3">246</div>
                </a>
                <a @click="turnPage(250)" class="row list">
                    <div class="col-xs-12 col-sm-9">After Midnight</div>
                    <div class="hidden-xs col-sm-3">248</div>
                </a>
                <a @click="turnPage(260)" class="row list">
                    <div class="col-xs-12 col-sm-9">The Battle for Yemen</div>
                    <div class="hidden-xs col-sm-3">258</div>
                </a>
                <a @click="turnPage(266)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue – Olivia Colman</div>
                    <div class="hidden-xs col-sm-3">264</div>
                </a>
                <a @click="turnPage(268)" class="row list">
                    <div class="col-xs-12 col-sm-9">A Humanitarian Disaster—and the Forgotten Refugees</div>
                    <div class="hidden-xs col-sm-3">266</div>
                </a>
                <a @click="turnPage(282)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Maya Siegel</div>
                    <div class="hidden-xs col-sm-3">280</div>
                </a>
                <a @click="turnPage(286)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Priyanka Chopra Jonas</div>
                    <div class="hidden-xs col-sm-3">284</div>
                </a>
                <a @click="turnPage(288)" class="row list">
                    <div class="col-xs-12 col-sm-9">Fashion-V for Valentino</div>
                    <div class="hidden-xs col-sm-3">286</div>
                </a>
                <a @click="turnPage(302)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Quincy Jones</div>
                    <div class="hidden-xs col-sm-3">300</div>
                </a>
                <a @click="turnPage(304)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Nitish Sood</div>
                    <div class="hidden-xs col-sm-3">302</div>
                </a>
                <a @click="turnPage(308)" class="row list">
                    <div class="col-xs-12 col-sm-9">To Infinity and Beyond</div>
                    <div class="hidden-xs col-sm-3">306</div>
                </a>
                <a @click="turnPage(316)" class="row list">
                    <div class="col-xs-12 col-sm-9">Beauty–Citizens of Humanity</div>
                    <div class="hidden-xs col-sm-3">314</div>
                </a>
                <a @click="turnPage(330)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Rishab Jain</div>
                    <div class="hidden-xs col-sm-3">328</div>
                </a>
                <a @click="turnPage(332)" class="row list">
                    <div class="col-xs-12 col-sm-9">Where Academia Meets Instagram</div>
                    <div class="hidden-xs col-sm-3">330</div>
                </a>
                <a @click="turnPage(338)" class="row list">
                    <div class="col-xs-12 col-sm-9">A Critical Lens </div>
                    <div class="hidden-xs col-sm-3">336</div>
                </a>
                <a @click="turnPage(352)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Shona Beecham</div>
                    <div class="hidden-xs col-sm-3">350</div>
                </a>
                <a @click="turnPage(356)" class="row list">
                    <div class="col-xs-12 col-sm-9">Revolution Road</div>
                    <div class="hidden-xs col-sm-3">354</div>
                </a>
                <a @click="turnPage(364)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Steve Aoki </div>
                    <div class="hidden-xs col-sm-3">362</div>
                </a>
                <a @click="turnPage(366)" class="row list">
                    <div class="col-xs-12 col-sm-9">Fashion - I Am Me</div>
                    <div class="hidden-xs col-sm-3">364</div>
                </a>
                <a @click="turnPage(388)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue – Umi  </div>
                    <div class="hidden-xs col-sm-3">386</div>
                </a>
                <a @click="turnPage(390)" class="row list">
                    <div class="col-xs-12 col-sm-9">Fashion-Joy Division</div>
                    <div class="hidden-xs col-sm-3">388</div>
                </a>
                <a @click="turnPage(404)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Virgil Abloh'</div>
                    <div class="hidden-xs col-sm-3">402</div>
                </a>
                <a @click="turnPage(406)" class="row list">
                    <div class="col-xs-12 col-sm-9">Fashion-Vogue Vogue</div>
                    <div class="hidden-xs col-sm-3">404</div>
                </a>
                <a @click="turnPage(418)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Whoopi Goldberg</div>
                    <div class="hidden-xs col-sm-3">416</div>
                </a>
                <a @click="turnPage(420)" class="row list">
                    <div class="col-xs-12 col-sm-9">Fashion-Express Yourself</div>
                    <div class="hidden-xs col-sm-3">418</div>
                </a>
                <a @click="turnPage(444)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Yusef Salaam</div>
                    <div class="hidden-xs col-sm-3">442</div>
                </a>
                <a @click="turnPage(446)" class="row list">
                    <div class="col-xs-12 col-sm-9">YOUTH SERIES: Sophie Bernstein </div>
                    <div class="hidden-xs col-sm-3">444</div>
                </a>
                <a @click="turnPage(448)" class="row list">
                    <div class="col-xs-12 col-sm-9">Testimonials </div>
                    <div class="hidden-xs col-sm-3">446</div>
                </a>
                <a @click="turnPage(452)" class="row list">
                    <div class="col-xs-12 col-sm-9">#HumanIssue - Zac Efron</div>
                    <div class="hidden-xs col-sm-3">450</div>
                </a>
                <a @click="turnPage(454)" class="row list">
                    <div class="col-xs-12 col-sm-9">Stockists </div>
                    <div class="hidden-xs col-sm-3">452</div>
                </a>
                <a @click="turnPage(458)" class="row list">
                    <div class="col-xs-12 col-sm-9">Code of Ethicss</div>
                    <div class="hidden-xs col-sm-3">456</div>
                </a>
                <a @click="turnPage(459)" class="row list">
                    <div class="col-xs-12 col-sm-9">Next Issue </div>
                    <div class="hidden-xs col-sm-3">457</div>
                </a>                    
            </div>
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery';
import '@/lib/turn.min.js';
import {
    mapMutations
} from "vuex";

export default {

    data() {
        return {

        }
    },
    methods: {
        turnPage(num) {
            $('.flipbook').turn("page", num)
            this.setClass(false)
        },
        ...mapMutations('magazine', [
            'setClass'
        ]),

    },
}
</script>

<style lang="scss">
.overlay-menu {
    position: absolute;
    background: white;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow-x: hidden;
    overflow-y: scroll;
    top: 0px;
}

#projets .th.row.list div:last-child,
#projets a.row.list div:last-child {
    text-align: right;
    font-family: 'CaslonOldFace';
}

#projets .row.list div:first-child {
    display: inline;
    font-family: 'CaslonOldFace';
}

#projets .row.th div {
    font-weight: 600;
    color: rgba(10, 0, 30, .25);
    text-transform: uppercase;
    font-size: .8em;
    letter-spacing: .1em;
    margin-left: -10%;
}

#projets .row.list div {
    font-size: 1.2em;
    padding-top: .6em;
    padding-bottom: .6em;
    font-weight: 200;
    line-height: 0.6em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
}

.tablecon {
    padding-left: 25%;
    padding-right: 25%;
    padding-top: 10%;
    padding-bottom: 10%;

    a {
        text-decoration: none;
        color: black;
        opacity: .5;
        cursor: pointer;
    }

    a:hover {
        color: black;
        font-weight: 900;
        opacity: 5;
        font-size: 1.2em;
    }
}

.titlecont {
    font-size: x-large !important;
    padding-bottom: 75px !important;
    text-align: center !important;
}
</style>
